import Shop from "../../container/shop";

export default Shop;
